export default __webpack_public_path__ + "static/media/sneakers-vault.b6678e1c.svg";